<template>
  <div class="add-drop-dots">&#xFE19;</div>
  <div class="row m-0">
    <!-- <div class="col-2">
      <i class="bi bi-geo-alt-fill"></i>
      <fa fas icon="map-marker-alt"></fa>
    </div> -->
    <div class="col-10">
      <i class="bi bi-geo-alt-fill"></i>
      <input
        ref="placeInput"
        type="text"
        class="custom-drop-pac-input drop-input"
        placeholder="Drop"
        data-location-name=""
      />
    </div>
    <div class="col-2">
      <i class="bi bi-x" style="font-size: 30px" @click="removeDropoff"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddDropoff',
  props: ['id', 'kv', 'autocomplete', 'google'],
  mounted() {
    let input = this.$refs.placeInput;
    if (input.dataset.locationName) {
      input.value = '';
      input.dataset.locationName = '';
    }
    let placeAutocomplete = new this.google.maps.places.Autocomplete(input, {
      componentRestrictions: {
        country: 'BD'
      }
    });

    placeAutocomplete.addListener('place_changed', () => {
      let place = placeAutocomplete.getPlace();
      this.setDropoff(place, input.dataset.locationName);
      input.value = place.name;
      input.dataset.locationName = place.name;
    });
  },
  methods: {
    setDropoff(place, oldPlaceName) {
      // this.$emit('dropoff', place, this.id);
      this.$emit('dropoff', place, oldPlaceName);
    },
    removeDropoff() {
      let input = this.$refs.placeInput;
      this.$emit('removedropoff', this.kv, input.dataset.locationName);
    }
  },
  emits: ['dropoff', 'removedropoff']
};
</script>

<style scoped>
input {
  border: 0;
  outline: 0;
  border-bottom: 2px solid #c4c4c4;
  font-size: 18px;
  width: 85%;
  color: #4f4949;
  margin-left: 15px;
  /* margin: -10px -40px; */
}

.add-drop-dots {
  font-size: 42px;
  margin-bottom: -6px;
  margin-top: -5px !important;
}

.bi {
  cursor: pointer;
  color: #652f8f;
}
.bi-x {
  color: #b1b1b1;
  margin-left: 10px;
}
</style>
